module.exports = __webpack_public_path__ + "static/media/03_360.a8511833.jpeg";